"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFreeAiDailyBudgetDocument = exports.FREE_AI_DAILY_LIMIT = void 0;
exports.FREE_AI_DAILY_LIMIT = 10000;
const parseFreeAiDailyBudgetDocument = (value) => {
    const data = value;
    if (!data ||
        data.schemaVersion !== 1 ||
        !Number.isSafeInteger(data.utcDay) ||
        data.utcDay < 0 ||
        !Number.isSafeInteger(data.used) ||
        data.used < 0 ||
        data.used > exports.FREE_AI_DAILY_LIMIT)
        throw new Error('Invalid free AI daily budget.');
    return { schemaVersion: 1, utcDay: data.utcDay, used: data.used };
};
exports.parseFreeAiDailyBudgetDocument = parseFreeAiDailyBudgetDocument;
